/**
 * Events menu structure and category content for Panthi Events
 */

export const eventsMenu = [
  {
    id: "wedding",
    title: "Wedding Event",
    path: "/wedding-events",
    subItems: [
      "Destination Wedding",
      "Pre-Wedding",
      "Bachelor Party",
      "Kankotri Lekhan",
      "Mehndi Function",
      "Sangeet Sandhya",
      "Haldi Function",
      "Carnival Party",
      "Barat",
      "Wedding",
      "Reception function",
    ],
  },
  {
    id: "corporate",
    title: "Corporate Event",
    path: "/corporate-events",
    subItems: [
      "Corporate Meeting",
      "Conferences & Seminars",
      "Product Launching",
      "Corporate Parties",
      "Training Programs",
      "Team Building",
      "Award & Recognition",
      "Exhibitions & Trade Shows",
      "Networking Event",
      "CSR Event",
      "Virtual Event",
      "Press Conferences & Media Event",
    ],
  },
  {
    id: "social",
    title: "Social Event",
    path: "/social-events",
    subItems: [
      "Wedding Planning",
      "Proposal Party",
      "Ring Ceremony",
      "Baby Shower",
      "Birthday Party",
      "Welcome Party",
      "Naamkaran Ceremony",
      "Anniversary Celebration",
      "Festival Party",
      "Housewarming Celebration",
      "Family Get-Together",
      "Community Event",
      "Religious & Traditional Event",
      "Private Parties",
      "Other Event",
    ],
  },
  {
    id: "other",
    title: "Other Event",
    path: "/other-events",
    subItems: [
      "Kitty Party",
      "Sports Event",
      "Fashion Show",
      "Cooking Show",
      "Valentine Day",
      "College Event",
      "School Event",
      "Concert & Live Shows",
      "Mall Promotions & Activity Event",
      "Government Event",
      "NGO And Charity Event",
      "Cultural Festival Event",
      "Club Event",
      "Outdoor Event",
      "Talent Hunt Show",
      "Book Launch Event",
      "Movie Promotion Event",
    ],
  },
  {
    id: "concert",
    title: "Concert",
    path: "/concert-events",
    subItems: [
      "Concert",
      "New Year Party",
      "DJ Party",
      "Celebrity Live Concert",
      "Bollywood Night",
      "Corporate Concert Night",
      "College Concert",
    ],
  },
];

export const weddingContent = {
  tagline: "The Art Of Celebration",
  title: "Wedding Event",
  intro: `At Panthi Event, weddings are envisioned as grand, royal celebrations where elegance, tradition, and emotion come together in perfect harmony. We believe a wedding is not just a ceremony but a timeless experience that deserves exceptional planning, artistic design, and flawless execution.

Every wedding curated by Panthi Event is uniquely crafted to reflect the couple's story, cultural heritage, and refined taste. From concept creation to final execution, our team works with meticulous attention to detail, ensuring that every element—from décor and lighting to ambience and flow—exudes luxury and sophistication.

Whether it is an intimate traditional wedding or a magnificent destination celebration, Panthi Event brings creativity, discipline, and royal aesthetics together. We manage every aspect seamlessly, allowing families and couples to enjoy their special moments with complete peace of mind.

With years of expertise in the event industry, Panthi Event is known for delivering weddings that are graceful, memorable, and flawlessly managed. Our experienced team, premium resources, and commitment to excellence transform your wedding into an unforgettable royal affair.

Panthi Event — Creating Weddings with Timeless Elegance.`,

  bannerImageAlt:
    "Wedding event decoration and stage design by Panthi Events in Ahmedabad, Gujarat, India",
  faq: [
    {
      question: "Do you plan weddings only in Ahmedabad and Gujarat?",
      answer:
        "We plan weddings across Gujarat and India, including destination weddings. Our team is based in Ahmedabad and frequently manages celebrations in Surat, Vadodara, Rajkot, and other cities with the same production standards.",
    },
    {
      question:
        "Can Panthi Event manage full wedding production (stage, LED, sound)?",
      answer:
        "Yes. We provide end-to-end wedding event management including stage design, lighting, sound, LED content, artist coordination, and on-ground crew so your functions run on schedule.",
    },
    {
      question: "Do you help with budget planning for large Indian weddings?",
      answer:
        "We prepare clear estimates, prioritize spend across functions, and recommend trusted vendors so you get value without compromising guest experience or safety.",
    },
    {
      question: "What is the typical cost of a wedding planner in Ahmedabad?",
      answer:
        "Fees depend on guest count, number of functions, production scale, and travel. We share transparent estimates after understanding your venues in Ahmedabad or Gujarat and your décor and entertainment priorities.",
    },
    {
      question:
        "Who is the best event management company in Gujarat for weddings?",
      answer:
        "Look for end-to-end execution: clear run sheets, in-house production partners, and calm on-site managers. Panthi Events combines planning, décor, and technical production for weddings across Gujarat and India.",
    },
    {
      question: "Do you plan destination weddings from Ahmedabad?",
      answer:
        "Yes. We coordinate travel, room blocks, vendor logistics, and on-site production so destination weddings feel seamless for families travelling from Gujarat and other states.",
    },
    {
      question: "Can you manage Gujarati or fusion wedding rituals?",
      answer:
        "Our team plans traditional and fusion formats with respectful ritual setups, bilingual coordination, and timelines that keep priests, families, and entertainment aligned.",
    },
    {
      question: "How early should we book a wedding planner in Gujarat?",
      answer:
        "Popular dates and venues fill fast—ideally 6–12 months ahead for large weddings. Shorter timelines are possible when venues and vendors have availability.",
    },
  ],

  whyChoose: [
    "Complete Wedding Planning & Execution",
    "Creative & Customized Wedding Concepts",
    "Experienced Wedding Management Team",
    "Premium Decoration & Production Quality",
    "Strong Vendor & Venue Network",
    "Guest Comfort & Hospitality Focus",
    "On-Time Execution & Professional Coordination",
    "Latest Wedding Trends & Modern Technology",
    "Budget Friendly & Transparent Planning",
    "Stress-Free Wedding Experience",
  ],
  letsPlanTitle: "Let's Plan Your Wedding Event",
  letsPlanText: `Your wedding is one of the most special moments of your life, and Panthi Event Management is here to make it beautiful, grand, and stress-free. Our team works closely with you to understand your vision, theme ideas, and wedding requirements, ensuring smooth planning and professional execution. Whether it is a destination wedding, traditional wedding, or theme-based celebration, we are committed to creating a seamless and memorable wedding experience for you and your family.`,
  subEvents: [
    {
      name: "Destination Wedding",
      description:
        "Destination weddings are about celebrating love at beautiful and unique locations. Our team provides complete destination wedding planning services including location research, venue finalization, guest accommodation planning, travel coordination, decoration planning, vendor management, and complete event execution.",
    },
    {
      name: "Ring Ceremony",
      description:
        "Ring ceremony is the first official celebration of the wedding journey. We design elegant ring ceremony events with romantic stage decoration, couple entry concepts, LED backdrop design, lighting setup, and music arrangements.",
    },
    {
      name: "Pre-Wedding",
      description:
        "Pre-wedding celebrations and shoots help couples create beautiful memories before their big day. We help in planning creative pre-wedding shoots by selecting suitable locations, theme concepts, styling coordination, and shoot management.",
    },
    {
      name: "Bachelor Party",
      description:
        "Bachelor parties are fun and energetic celebrations before marriage. We plan complete bachelor party experiences including venue selection, DJ and music arrangements, entertainment planning, theme decoration, and full event management.",
    },
    {
      name: "Kankotri Lekhan",
      description:
        "Kankotri Lekhan is a traditional ceremony with cultural importance. We design traditional decoration setups with modern elegance, comfortable seating arrangements, and theme-based decoration concepts.",
    },
    {
      name: "Mehndi Function",
      description:
        "Mehndi function is full of colors, music, and happiness. We create beautiful Mehndi decoration setups using floral décor, colorful drapes, designer seating lounges, stage setup, and live music arrangements.",
    },
    {
      name: "Sangeet Sandhya",
      description:
        "Sangeet is one of the most energetic wedding functions. We design grand Sangeet stage setups including LED wall stage design, professional sound systems, choreography coordination, and lighting effects.",
    },
    {
      name: "Haldi Function",
      description:
        "Haldi ceremony is a traditional and emotional wedding ritual. We design Haldi theme decoration using yellow floral décor, seating arrangements, ritual setup areas, and photography-friendly backgrounds.",
    },
    {
      name: "Carnival Party",
      description:
        "Carnival theme wedding events create a fun and festival-like experience. We arrange game stalls, fun activity zones, kids entertainment areas, food counters, and colorful decoration setups.",
    },
    {
      name: "Barat",
      description:
        "Baarat is one of the most energetic parts of the wedding. We manage complete Baarat planning including band, DJ, entry vehicle arrangements, horse or vintage car arrangements, and on-ground coordination.",
    },
    {
      name: "Wedding Function",
      description:
        "Wedding day requires perfect planning and coordination. We manage complete wedding ceremony setup including Mandap design, stage decoration, seating planning, sound and lighting setup, and ritual coordination.",
    },
    {
      name: "Reception function",
      description:
        "Reception is a grand celebration event. We create luxury reception stage setups, LED backdrop design, couple entry planning, entertainment arrangements, and guest hospitality management.",
    },
  ],
};

export const corporateContent = {
  tagline: "Where Corporate Vision Meets Perfect Event Execution.",
  title: "Corporate Event",
  intro: `Panthi Event Management delivers professionally planned and flawlessly executed corporate events designed to enhance brand presence, business communication, and corporate engagement. We specialize in managing end-to-end corporate event solutions including planning, production, branding integration, guest management, and technical execution. Our focus is to create impactful corporate experiences that reflect professionalism, innovation, and business excellence.

With strong industry experience, advanced production technology, and a highly skilled event team, we ensure every corporate event is managed with precision, quality, and attention to detail. From business meetings to large-scale corporate gatherings, Panthi Event Management is committed to delivering seamless, high-quality, and result-driven corporate event experiences.`,
  bannerImageAlt:
    "Corporate conference and stage branding by Panthi Events — Ahmedabad, Gujarat, India",
  faq: [
    {
      question: "Which corporate events do you manage in Gujarat?",
      answer:
        "We manage conferences, seminars, product launches, awards, exhibitions, networking events, CSR programs, virtual or hybrid meetings, and press briefings—end to end—in Ahmedabad and across Gujarat, with India-wide execution where required.",
    },
    {
      question:
        "Can you handle AV, LED, and live streaming for corporate shows?",
      answer:
        "Yes. We provide sound, lighting, LED walls, presentation switching, and streaming setups with technicians on site so your program stays on schedule.",
    },
    {
      question: "Do you support branded staging and print for exhibitions?",
      answer:
        "Our team coordinates flex, standees, stall design partners, and on-site installation so your booth and stage match brand guidelines.",
    },
    {
      question: "What does corporate event management cost in Ahmedabad?",
      answer:
        "Investment varies with delegate count, AV complexity, venue, and run length. We scope objectives first, then propose line items for staging, LED, streaming, and crew so finance teams can approve with confidence.",
    },
    {
      question:
        "Can Panthi Events act as a corporate event organizer across India?",
      answer:
        "Yes. We run programmes in Ahmedabad and Gujarat and support multi-city roadshows with consistent branding, travel-aware crewing, and rehearsal discipline.",
    },
    {
      question: "Do you support hybrid and virtual corporate events?",
      answer:
        "We provide streaming setups, platform coordination, remote speaker support, and on-site direction so virtual and hybrid audiences stay engaged.",
    },
    {
      question: "Which industries do you serve for corporate events?",
      answer:
        "We support IT, manufacturing, retail, pharma, education, and public-sector formats—anywhere clear staging, AV, and delegate flow matter for your brand.",
    },
    {
      question:
        "How do you measure success for a corporate launch or conference?",
      answer:
        "We align on KPIs upfront—registration completion, show timing, media capture, and audience feedback—then debrief with your team after the event.",
    },
  ],

  whyChoose: [
    "Professional Planning & Execution",
    "Experienced Corporate Event Team",
    "Latest AV & Production Technology",
    "Customized Corporate Solutions",
    "On-Time Event Delivery",
    "Strong Vendor & Venue Network",
  ],
  letsPlanTitle: "Let's Plan Your Corporate Event",
  letsPlanText: `Panthi Event Management is committed to delivering high-quality corporate event experiences with professionalism, creativity, and perfect execution. Whether it is a small meeting or a large corporate event, our team ensures smooth planning and successful event execution.`,
  subEvents: [
    {
      name: "Corporate Meeting",
      description:
        "Professional corporate meeting management services including venue selection, meeting room setup, audio-visual setup, presentation support, and guest coordination.",
    },
    {
      name: "Conferences & Seminars",
      description:
        "Complete event planning and production support including stage setup, branding backdrop design, LED screen setup, delegate registration management, and hospitality services.",
    },
    {
      name: "Product Launching",
      description:
        "Impactful product launch events with creative stage design, product display setup, lighting effects, LED presentation setup, and media coordination.",
    },
    {
      name: "Corporate Parties",
      description:
        "Corporate celebration events including annual parties, festival celebrations, success parties—with venue decoration, entertainment planning, and catering coordination.",
    },
    {
      name: "Training Programs",
      description:
        "Professional training hall setup, projector and AV setup, participant registration support, and hospitality services for productive learning environments.",
    },
    {
      name: "Team Building",
      description:
        "Indoor and outdoor team building activities, corporate engagement programs, and fun learning experiences with proper activity planning and safety management.",
    },
    {
      name: "Award & Recognition",
      description:
        "Premium award and recognition events with stage setup, award presentation setup, branding backdrop design, and event show flow management.",
    },
    {
      name: "Exhibitions & Trade Shows",
      description:
        "Stall design, brand display setup, product display setup, visitor engagement planning, and exhibition coordination.",
    },
    {
      name: "Networking Event",
      description:
        "Professional networking events with venue setup, guest registration support, branding integration, and hospitality services.",
    },
    {
      name: "CSR Event",
      description:
        "CSR event planning and management including community event planning, social activity setup, volunteer management, and on-ground event coordination.",
    },
    {
      name: "Virtual Event",
      description:
        "Complete virtual event solutions including live streaming setup, virtual event platform management, online registration, and technical support.",
    },
    {
      name: "Press Conferences & Media Event",
      description:
        "Professional press conferences with media backdrop branding, media seating arrangement, audio setup, and media management.",
    },
  ],
};

export const socialContent = {
  tagline: "Where Every Celebration Becomes Unforgettable.",
  title: "Social Event",
  intro: `Social events are special occasions that bring families, friends, and communities together to celebrate life's most important moments. At Panthi Event Management, we believe every celebration should be unique, well-planned, and memorable. Our team focuses on understanding your event purpose, theme preferences, and overall expectations to design a celebration that reflects your style and emotions.

We provide complete social event planning and execution services, including venue selection, theme-based decoration, catering management, entertainment arrangements, guest hospitality, and on-ground event coordination. From wedding-related functions, birthday parties, baby showers, anniversaries, proposal events, and festival celebrations to family get-togethers and traditional ceremonies, we manage every aspect professionally.

At Panthi Event Management, we combine modern event trends with traditional values to create events that are stylish, comfortable, and well-organized. Our goal is to turn your special occasions into unforgettable memories.`,
  bannerImageAlt:
    "Social celebration décor and family event planning — Panthi Events, Ahmedabad Gujarat",
  faq: [
    {
      question: "What social events do you plan in Ahmedabad?",
      answer:
        "We plan ring ceremonies, baby showers, birthdays, anniversaries, housewarmings, festival parties, family reunions, and community gatherings—with décor, catering coordination, and entertainment suited to your venue.",
    },
    {
      question: "Can you manage both traditional rituals and modern themes?",
      answer:
        "Yes. We blend ritual requirements with contemporary design, lighting, and music so every generation feels included.",
    },
    {
      question: "Do you provide vendors for smaller home events?",
      answer:
        "We can scale vendor support—from compact setups at home to full banquet productions—based on your budget and guest count.",
    },
    {
      question: "What is included in social event planning in Gujarat?",
      answer:
        "Typically venue alignment, décor direction, entertainment and sound basics, catering coordination, and on-site managers—scaled to your function size in Ahmedabad or other Gujarat cities.",
    },
    {
      question: "Can you plan bilingual family events?",
      answer:
        "Yes. We support Hindi, Gujarati, and English announcements so every generation understands schedules, entries, and safety notes.",
    },
    {
      question: "Do you handle catering and entertainment for ring ceremonies?",
      answer:
        "We coordinate trusted catering partners, live music or DJ options, and décor themes so ring ceremonies feel cohesive and photogenic.",
    },
    {
      question: "How far in advance should we book a social celebration?",
      answer:
        "Popular weekends book quickly—3–6 months ahead is ideal for banquets; intimate home events may need less lead time if vendors are available.",
    },
    {
      question: "Can social events use the same production as weddings?",
      answer:
        "Yes. When you need LED, truss, or concert-grade audio, we align with our wedding and production teams for consistent quality.",
    },
  ],

  whyChoose: [
    "Complete Social Event Planning & Execution",
    "Creative & Customized Celebration Concepts",
    "Experienced & Professional Event Management Team",
    "Premium Decoration & Setup Quality",
    "Strong Vendor & Venue Network",
    "Guest Comfort & Hospitality Focus",
    "On-Time Execution & Smooth Coordination",
    "Latest Event Trends & Modern Technology",
    "Transparent Pricing & Budget Friendly Planning",
    "Stress-Free Celebration Experience",
    "One-Stop Solution for All Social Events",
  ],
  letsPlanTitle: "Let's Plan Your Social Event",
  letsPlanText: `Every social event is a special moment to celebrate happiness, togetherness, and memories with your loved ones. At Panthi Event Management, we are dedicated to turning your celebrations into beautifully planned and stress-free experiences. From small family gatherings to grand social celebrations, we manage everything with creative concepts, premium setups, and professional execution.`,
  subEvents: [
    {
      name: "Wedding Planning",
      description:
        "End-to-end luxury wedding planning from premium venue selection and theme conceptualization to high-end décor, gourmet catering, and guest hospitality.",
    },
    {
      name: "Proposal Party",
      description:
        "Exclusive and romantic proposal setups with customized décor concepts, premium floral arrangements, ambient lighting, and surprise planning.",
    },
    {
      name: "Ring Ceremony",
      description:
        "Elegant ring ceremony planning with designer stage setups, luxury décor themes, grand entry concepts, and professional photography.",
    },
    {
      name: "Baby Shower",
      description:
        "Beautifully designed baby shower celebrations with premium theme décor, customized setups, entertainment activities, and catering arrangements.",
    },
    {
      name: "Birthday Party",
      description:
        "Complete party planning from luxury kids' birthday themes to premium adult celebrations—designer décor, entertainment, and full event management.",
    },
    {
      name: "Welcome Party",
      description:
        "Grand and stylish welcome party planning with premium décor, lighting design, music arrangements, and guest reception management.",
    },
    {
      name: "Naamkaran Ceremony",
      description:
        "Traditional yet premium naamkaran ceremonies with elegant décor, customized pooja setup, and family guest management.",
    },
    {
      name: "Anniversary Celebration",
      description:
        "Romantic and luxurious anniversary celebrations with premium décor, memory walls, photo setups, and fine dining arrangements.",
    },
    {
      name: "Festival Party",
      description:
        "Festival event planning combining cultural tradition with modern luxury—theme-based décor, cultural setup, and premium catering.",
    },
    {
      name: "Housewarming Celebration",
      description:
        "Elegant housewarming celebrations with traditional pooja setup, floral décor, entrance styling, and catering coordination.",
    },
    {
      name: "Family Get-Together",
      description:
        "Comfortable family gatherings with customized décor themes, entertainment arrangements, and smooth event coordination.",
    },
    {
      name: "Community Event",
      description:
        "Large-scale community events with professional event management, stage setup, sound and lighting, and crowd management.",
    },
    {
      name: "Religious & Traditional Event",
      description:
        "Respectful planning of religious and traditional events with proper rituals setup, traditional décor, and guest management.",
    },
    {
      name: "Private Parties",
      description:
        "Stylish and exclusive private party experiences with premium décor, lighting design, entertainment, and personalized setups.",
    },
  ],
};

export const otherContent = {
  tagline: "Your Moments, Our Passion for Perfect Celebrations.",
  title: "Other Event",
  intro: `At Panthi Event Management, we understand that every event is unique and requires specialized planning, creative execution, and professional coordination. We provide complete management solutions for a wide range of events including kitty parties, sports events, fashion shows, cooking shows, Valentine's Day events, college and school events, concerts and live shows, mall promotions, government events, NGO and charity events, cultural festivals, club events, outdoor events, talent hunt shows, book launch events, and movie promotion events.

From venue selection, stage setup, branding and promotional setup, sound and lighting, artist coordination, crowd management, and guest hospitality to complete on-ground execution, we ensure smooth and successful event delivery. Whether it is a promotional event, entertainment show, institutional event, or public gathering, Panthi Event Management is committed to delivering well-organized, engaging, and high-quality event experiences.`,
  bannerImageAlt:
    "Public and promotional event production — Panthi Events, Gujarat India",
  faq: [
    {
      question:
        "Can Panthi Event manage government or school events with protocols?",
      answer:
        "Yes. We align seating, security, VIP movement, and stage protocols with institutional requirements while keeping production quality high.",
    },
    {
      question: "Do you handle outdoor events and crowd management?",
      answer:
        "We plan power, sound, barricading, and entry-exit flows with trained crew partners so outdoor programs stay safe and organized.",
    },
    {
      question: "What promotional setups do you support?",
      answer:
        "From mall activations and brand roadshows to fashion shows and movie promotions, we manage stage, branding, artists, and media coordination.",
    },
    {
      question:
        "What is the cost of a fashion show or sports day in Ahmedabad?",
      answer:
        "Budgets scale with footprint, rigging, broadcast needs, and artist fees. We itemize staging, sound, LED, manpower, and safety so sponsors and institutions can approve quickly.",
    },
    {
      question: "Can you manage permissions for outdoor events in Gujarat?",
      answer:
        "We support documentation, venue liaison, and safety planning with your legal and admin teams—timelines vary by location and audience size.",
    },
    {
      question: "Do you provide crowd control for public programmes?",
      answer:
        "We work with trained security and volunteer briefings, entry-exit design, and barricading partners for orderly audience flow.",
    },
    {
      question: "Are NGO and charity events handled differently?",
      answer:
        "We respect mission-first messaging, volunteer coordination, and cost-conscious production while keeping stages safe and dignified.",
    },
    {
      question: "Can school and college events include celebrity appearances?",
      answer:
        "Yes, when budgets and contracts allow—we coordinate artist riders, security, and rehearsal windows alongside academic schedules.",
    },
  ],

  whyChoose: [
    "Complete Planning & Professional Execution",
    "Creative & Customized Event Concepts",
    "Experienced & Skilled Event Management Team",
    "Premium Setup & High-Quality Production",
    "Strong Vendor, Artist & Venue Network",
    "Smooth Coordination & On-Time Execution",
    "Guest & Audience Experience Focus",
    "One-Stop Solution for All Types of Events",
    "Strong Crowd Management & Event Flow Control",
    "Stress-Free Event Management Experience",
  ],
  letsPlanTitle: "Let's Plan Your Other Event",
  letsPlanText: `Every event is unique and requires proper planning, creativity, and professional execution. At Panthi Event Management, we are dedicated to turning your event ideas into well-organized and successful experiences. From promotional events, entertainment shows, institutional events, to public gatherings, we manage everything with creative concepts, modern technology, and experienced professionals.`,
  subEvents: [
    {
      name: "Kitty Party",
      description:
        "Stylish and well-organized kitty party experiences with creative décor themes, entertainment activities, game planning, and catering arrangements.",
    },
    {
      name: "Sports Event",
      description:
        "Complete sports event management including ground setup, branding setup, stage and podium arrangements, registration management, and prize distribution.",
    },
    {
      name: "Fashion Show",
      description:
        "Professional fashion shows with ramp setup, backstage management, model coordination, lighting and sound setup, and show flow management.",
    },
    {
      name: "Cooking Show",
      description:
        "Stage setup, kitchen setup arrangement, branding display, audience seating, and smooth show coordination.",
    },
    {
      name: "Valentine Day",
      description:
        "Romantic and themed Valentine's Day events with creative décor, lighting design, entertainment, and premium dining setup.",
    },
    {
      name: "College Event",
      description:
        "Complete college event management with stage setup, sound and lighting, artist coordination, crowd management, and branding setup.",
    },
    {
      name: "School Event",
      description:
        "School event planning including annual day, sports day, cultural programs, stage setup, and student performance coordination.",
    },
    {
      name: "Concert & Live Shows",
      description:
        "Professional stage production, advanced sound and lighting, artist coordination, backstage management, and crowd control.",
    },
    {
      name: "Mall Promotions & Activity Event",
      description:
        "Mall promotions and brand activation events with creative setup designs, branding displays, and audience engagement.",
    },
    {
      name: "Government Event",
      description:
        "Government and public sector events with protocol handling, stage and seating arrangements, and security coordination.",
    },
    {
      name: "NGO And Charity Event",
      description:
        "Stage setup, branding and awareness setup, donation activity planning, and volunteer coordination for meaningful social events.",
    },
    {
      name: "Cultural Festival Event",
      description:
        "Theme-based décor, traditional stage setup, cultural performance arrangements, and crowd management.",
    },
    {
      name: "Club Event",
      description:
        "High-energy club events with professional lighting, DJ and sound setup, stage production, and crowd coordination.",
    },
    {
      name: "Outdoor Event",
      description:
        "Outdoor event management with location planning, weather backup, stage and tent setup, and safety coordination.",
    },
    {
      name: "Talent Hunt Show",
      description:
        "Professional stage setup, audition planning, judge coordination, participant registration, and result and award planning.",
    },
    {
      name: "Book Launch Event",
      description:
        "Premium stage setup, branding backdrop, media and press setup, author interaction setup, and smooth event flow.",
    },
    {
      name: "Movie Promotion Event",
      description:
        "Stage and branding setup, media coordination, celebrity management, and promotional activity planning.",
    },
  ],
};

export const concertContent = {
  tagline: "Feel the Music, Experience the Energy.",
  title: "Concert",
  intro: `Concert events are all about energy, entertainment, and creating unforgettable live experiences for the audience. At Panthi Event Management, we specialize in planning and executing high-quality concert events with professional production, creative stage design, and seamless event coordination. Whether it is a live music concert, celebrity show, DJ night, cultural music concert, or large-scale music festival, our team ensures every concert is planned with precision and executed flawlessly.

We provide complete concert event management services including venue planning, stage and truss setup, advanced sound and lighting design, LED wall and visual setup, artist and performer coordination, backstage management, ticketing support, crowd control, and security coordination. At Panthi Event Management, we combine modern event technology, creative production concepts, and professional expertise to deliver high-energy and impactful concert experiences.`,
  bannerImageAlt:
    "Concert stage lighting and live show production — Panthi Events, Gujarat India",
  faq: [
    {
      question: "What concert formats do you produce in Gujarat?",
      answer:
        "We produce DJ nights, Bollywood nights, celebrity live shows, college concerts, New Year events, and corporate entertainment nights—with stage, sound, LED, SFX, and crowd management.",
    },
    {
      question: "Do you manage artist hospitality and security?",
      answer:
        "Yes. We coordinate green rooms, travel, security briefings, and entry protocols so artists and VIP guests move smoothly through the venue.",
    },
    {
      question: "Can you support ticketing and entry management?",
      answer:
        "We work with ticketing partners and on-ground teams for access control, wristbands, and audience flow to reduce queues and confusion.",
    },
    {
      question: "What is the budget range for a concert in Gujarat?",
      answer:
        "Spend ties to artist fees, rig size, LED, sound class, and security. We build scenarios—club format, college fest, or arena-style—so you can choose what matches ticket pricing or sponsor goals.",
    },
    {
      question:
        "Who is the best concert organizer in Gujarat for college fests?",
      answer:
        "Prioritize crews who document power paths, artist riders, and crowd plans. Panthi Events brings stage, audio, LED, and backstage workflows tested across Ahmedabad and Gujarat venues.",
    },
    {
      question:
        "Do you manage celebrity concerts and corporate concert nights?",
      answer:
        "Yes—from hospitality and security to show calling and SFX—we align brand expectations with technical reality for both public and invite-only shows.",
    },
    {
      question: "Can concerts include fireworks or laser effects safely?",
      answer:
        "Where venues and regulations allow, we coordinate SFX partners, safety distances, and rehearsal cues with fire and venue teams.",
    },
    {
      question: "How do you reduce noise complaints for outdoor concerts?",
      answer:
        "We plan directional audio, curfew alignment with local norms, and neighbour communication when required—especially for urban Ahmedabad locations.",
    },
  ],

  whyChoose: [
    "Complete Concert Planning & Professional Execution",
    "High-End Stage, Sound & Lighting Production",
    "Experienced Concert & Show Management Team",
    "Strong Artist, DJ & Celebrity Network",
    "Advanced Event Technology & Visual Effects",
    "Smooth Crowd Management & Security Coordination",
    "Premium Event Setup & Production Quality",
    "On-Time Event Execution & Technical Coordination",
    "Ticketing, Entry & Audience Flow Management",
    "VIP & Artist Hospitality Management",
    "Large-Scale Event Handling Expertise",
    "Stress-Free Concert Event Management",
  ],
  letsPlanTitle: "Let's Plan Your Concert",
  letsPlanText: `A concert is more than just a music event—it is an experience filled with energy, excitement, and unforgettable moments. At Panthi Event Management, we are dedicated to turning your concert vision into a perfectly planned and professionally executed live show. From venue selection, stage and truss design, advanced sound and lighting, artist coordination, to crowd management and security planning, we handle every detail with precision and professionalism.`,
  subEvents: [
    {
      name: "Concert",
      description:
        "Complete concert event planning with professional stage production, advanced sound and lighting setup, LED wall visuals, artist coordination, and crowd management.",
    },
    {
      name: "New Year Party",
      description:
        "Grand and energetic New Year party events with theme-based décor, DJ and music setup, countdown celebration planning, and entertainment activities.",
    },
    {
      name: "DJ Party",
      description:
        "Premium sound system setup, DJ console setup, lighting and laser effects, stage setup, and dance floor setup for an electrifying party environment.",
    },
    {
      name: "Celebrity Live Concert",
      description:
        "Complete celebrity concert management including celebrity coordination, security planning, stage production, and VIP guest management.",
    },
    {
      name: "Bollywood Night",
      description:
        "Bollywood night concert events with theme décor, live performers or DJ setup, stage production, and dance and entertainment planning.",
    },
    {
      name: "Corporate Concert Night",
      description:
        "Premium stage setup, branded event setup, professional lighting and sound production, and guest management for corporate entertainment.",
    },
    {
      name: "College Concert",
      description:
        "Complete college concert event management including stage setup, sound and lighting, artist or DJ coordination, and crowd management.",
    },
  ],
};

export const eventCategoryContent = {
  wedding: weddingContent,
  corporate: corporateContent,
  social: socialContent,
  other: otherContent,
  concert: concertContent,
};
